import { render, staticRenderFns } from "./claimForm.vue?vue&type=template&id=1bf6f9e9&scoped=true"
import script from "./claimForm.vue?vue&type=script&lang=js"
export * from "./claimForm.vue?vue&type=script&lang=js"
import style0 from "./claimForm.vue?vue&type=style&index=0&id=1bf6f9e9&prod&lang=scss"
import style1 from "./claimForm.vue?vue&type=style&index=1&id=1bf6f9e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf6f9e9",
  null
  
)

export default component.exports